import { useEffect } from "react";

import { trackStaffEvent } from "./mixpanel";

/** Sends "Staff Searched" once typing pauses, not on every keystroke. */
export const useSearchTracking = (
  where: "menu" | "ingredients",
  query: string,
  resultsCount?: number
) => {
  useEffect(() => {
    const term = query.trim().toLowerCase();
    if (!term) return;
    const timer = setTimeout(
      () =>
        trackStaffEvent("Staff Searched", {
          where,
          query: term,
          results_count: resultsCount,
        }),
      1500
    );
    return () => clearTimeout(timer);
  }, [where, query, resultsCount]);
};
